import DevicesTable from "./DevicesTable";

export default DevicesTable